import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { platformRoute, platformTree } from '../platform/routes';

/**
 * `/platform/tagihan` — subscription invoices in the platform console (ADR-0033). A child of the
 * platform layout so it shares its rail shell and access check.
 */
export const platformBillingRoute = createRoute({
  getParentRoute: () => platformRoute,
  path: 'tagihan',
  component: lazyRouteComponent(() => import('./billing-page'), 'PlatformBillingPage'),
});

/**
 * The platform console's route tree plus the billing screen (until the console lists it among
 * its own children, at which point the router can use `platformTree` again).
 */
export const platformTreeWithBilling = platformRoute.addChildren([
  ...(platformTree.children ?? []),
  platformBillingRoute,
]);
